import { IScholarshipInfo, Presence } from '@studyportals/sp-scholarships-api-interface';
import { ResponseError } from 'superagent';
import { ScholarshipServiceIntegration } from '@/infrastructure/scholarship-service/scholarship-service-integration';
import ScholarshipPresenter from '@/presenters/scholarship-presenter';
import { Scholarship } from '@/presenters/scholarship';
import cookieHandler from '@/infrastructure/cookie-handler';

class ScholarshipService extends ScholarshipServiceIntegration {
	public async create(scholarshipInfo: IScholarshipInfo): Promise<string> {
		const tokenId = cookieHandler.retrieveTokenIdCookie();
		try {
			const scholarship = await this.v2Client.create(scholarshipInfo, tokenId);
			return scholarship.id;
		} catch (error) {
			this.tryThrowAbstractedError(error as ResponseError);
			throw error;
		}
	}

	public async update(
		scholarshipId: string,
		scholarshipInfo: IScholarshipInfo,
		presence: Presence
	): Promise<Scholarship> {
		const tokenId = cookieHandler.retrieveTokenIdCookie();
		try {
			return await ScholarshipPresenter.reconstitute(
				await this.v2Client.update(
					scholarshipId,
					scholarshipInfo,
					tokenId,
					presence as unknown as string | undefined
				)
			);
		} catch (error) {
			this.tryThrowAbstractedError(error as ResponseError);
			throw error;
		}
	}
}

export default new ScholarshipService();
